import PropTypes from "prop-types";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import MessageFormValidate from "./MessageFormValidate";

const ConfirmModal = props => {
  const {
    isOpen,
    toggle,
    titleHeader,
    titleBody,
    isHaveNote,
    notePlateHolder,
    textBtnCancel,
    textBtnConfirm,
    onConfirm,
    isDisableButton,
    isRequireNote,
    isReasonDeleteCheckbox,
    reasonList,
  } = props;

  const [isError, setIsError] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isReasonError, setIsReasonError] = useState(true);
  const [selectedReason, setSelectedReason] = useState(null);
  const [isRequiredReasonNote, setRequiredReasonNote] = useState(() => {
    return isRequireNote;
  });
  const { t } = useTranslation("common");
  const inputArea = useRef(null);

  const handleReasonChange = item => {
    if (item?.note_required == 0) {
      setIsError(false);
    }

    setSelectedReason({
      reasonId: item?.id,
      isRequired: item?.note_required,
    });
  };

  useEffect(() => {
    if (isOpen) {
    }
  }, [isOpen]);

  useEffect(() => {
    if (selectedReason) {
      setIsReasonError(false);
    }

    if (isRequireNote === undefined || isRequireNote === null) {
      setRequiredReasonNote(selectedReason?.isRequired === 1);
    }
  }, [selectedReason]);

  const validate = () => {
    setIsSubmitted(true);

    if (isRequiredReasonNote) {
      if (inputArea.current.value.trim() === "") {
        setIsError(true);
        return false;
      } else {
        setIsError(false);
      }
    }

    if (isReasonDeleteCheckbox) {
      if (selectedReason?.reasonId) {
        setIsReasonError(false);
      } else {
        setIsReasonError(true);
        return false;
      }
    }

    return true;
  };

  const handleSubmit = () => {
    const isValid = validate();
    if (!isValid) {
      return;
    }
    if (isReasonDeleteCheckbox) {
      if (isRequiredReasonNote) {
        onConfirm?.({
          note: inputArea.current ? inputArea.current.value : "",
          reasonId: selectedReason.reasonId,
        });
      } else {
        onConfirm?.({
          reasonId: selectedReason.reasonId,
        });
      }
    } else if (isHaveNote && inputArea.current.value !== "") {
      onConfirm?.(inputArea.current.value);
    } else {
      onConfirm && onConfirm();
    }
  };

  return (
    <Modal
      size="md"
      contentClassName="confirm-modal"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      toggle={() => toggle()}
    >
      <div className="modal-content">
        <ModalHeader toggle={() => toggle()}>{titleHeader}</ModalHeader>
        {(titleBody || isHaveNote) && (
          <ModalBody>
            <div style={{ fontSize: "15px" }} className="mb-3">
              {titleBody}
              {isRequiredReasonNote && <span className="text-danger"> *</span>}
            </div>
            {isReasonDeleteCheckbox && (
              <React.Fragment>
                <ul
                  style={{
                    listStyle: "none",
                    padding: "0",
                    display: "grid",
                    gridTemplateColumns: "50% 50%",
                  }}
                >
                  {reasonList?.map((item, index) => {
                    return (
                      <li key={index}>
                        <div>
                          <input
                            name="reason-radio"
                            type="radio"
                            id={`reason${item.id}`}
                            onChange={() => handleReasonChange(item)}
                          />
                          <label htmlFor={`reason${item.id}`} className="ms-2">
                            {item.reason}
                          </label>
                        </div>
                      </li>
                    );
                  })}
                </ul>
                {isReasonError && isSubmitted && (
                  <MessageFormValidate error={t("requiredReason")} />
                )}
              </React.Fragment>
            )}

            {isHaveNote && (
              <React.Fragment>
                <textarea
                  className={
                    `form-control mt-3 ` + (isError ? "is-invalid" : "")
                  }
                  ref={inputArea}
                  id="commentmessage-input"
                  placeholder={notePlateHolder}
                  rows="3"
                ></textarea>
                {isError && (
                  <MessageFormValidate
                    error={`${t("requiredInput")} ${titleBody}`}
                  />
                )}
              </React.Fragment>
            )}
          </ModalBody>
        )}
        <ModalFooter>
          <Button
            type="button"
            color="danger"
            disabled={isDisableButton}
            className="me-2 btn-label"
            onClick={() => toggle()}
          >
            <i className="bx bx-x label-icon" />
            {textBtnCancel ? textBtnCancel : "Bỏ qua"}
          </Button>
          <Button
            type="button"
            color="success"
            className="me-2 btn-label"
            disabled={isDisableButton}
            onClick={() => {
              handleSubmit();
            }}
          >
            <i className="bx bx-check label-icon" />
            {textBtnConfirm ? textBtnConfirm : "Đồng ý"}
          </Button>
        </ModalFooter>
      </div>
    </Modal>
  );
};

ConfirmModal.propTypes = {
  toggle: PropTypes.func,
  isOpen: PropTypes.bool,
  isHaveNote: PropTypes.bool,
  isRequireNote: PropTypes.bool,
  isReasonDeleteCheckbox: PropTypes.bool,
  titleHeader: PropTypes.string || PropTypes.element,
  titleBody: PropTypes.string,
  textBtnCancel: PropTypes.string,
  textBtnConfirm: PropTypes.string,
  notePlateHolder: PropTypes.string,
  isDisableButton: PropTypes.bool,
  onConfirm: PropTypes.func,
  reasonList: PropTypes.array,
};

ConfirmModal.defaultProps = {
  isDisableButton: false,
  isRequireNote: undefined,
  isHaveNote: false,
};

export default ConfirmModal;
